import React from 'react'
export const LoaderPage = () => {
    return (
        <>
            <div style={{
                height: window.innerHeight - 100,
                display: "flex",
                alignItems: "center",
                width: "100%",
                background: "transparent",
                flexDirection: "column",
                justifyContent: "center"

            }}>
                {/* <img width="60px" src={"../../images/Spinner.svg"} alt="loader" style={{
                    borderRadius: "50%"
                }} /> */}
                <img alt='logo' style={{ height: "120px" }} src="../../images/logo-short.png" />
                {/* <div className={styles.loader}>
                    <div className={styles.loader_inner}>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default LoaderPage